export default __webpack_public_path__ + "static/media/KZ.T.19.2321 black.7242259f.svg";